import * as Redux from "redux";
import _ from "underscore";
import { isDev } from "../../core/detection";
import { handleError } from "../errorHandler";
import { isErrorAction } from "./reducers";

type ThunkOrAction = IThunkAction | IStoreAction;

const isThunk = (a: ThunkOrAction): a is IThunkAction => a["thunk"] != null;
const isStoreAction = (a: ThunkOrAction): a is IStoreAction => a["payload"] != null;

export const storeMiddleware: Redux.Middleware = store => next => a => {
  const action = a as any as ThunkOrAction;

  if (_.isFunction(a)) {
    return (a as any)(store.dispatch, store.getState);
  }
  else if (isThunk(action)) {
    return action.thunk(store.dispatch as ThunkDispatch, store.getState);
  }
  else if (isStoreAction(action) && isErrorAction(action)) {
    // redux-promise-middleware puts the error in the payload
    const error = action.payload || new Error("Unexpected error");
    handleError(error, store.dispatch);
  }

  return next(action) as any;
};

// Log each Redux action
export const logMiddleware: Redux.Middleware = () => next => action => {
  if (isDev) {
    console.debug(action.type);
  }
  return next(action) as any;
}
